import Vue from "vue";
import Router from "vue-router";
import { routes } from "./routes";

import auth from "../services/authService";
// note this instance is only used to for the login() method, i.e. no instance state is mutated.
// that will happen on the callback and on the "this.$auth" instance

Vue.use(Router);

let router = new Router({
   routes,
   mode: "history",
   scrollBehviour(to, from, savedPosition) {
      if (savedPosition) {
         return savedPosition;
      }
      if (to.hash) {
         return {
            selector: to.hash
         };
      }
   }
});



// old check
// router.beforeEach((to, from, next) => {
//
//    // used to take server offline but still display basic message to user
//
//    // if (to.path === '/offline'){
//    //    return next();
//    // }
//    // else{
//    //    next('/offline');
//    // }
//
//
//    if (to.path === "/auth-callback" || auth.isAuthenticated()) {
//       return next();
//
//    }
//    else{
//       // Specify the current path as the customState parameter, meaning it
//       // will be returned to the application after auth
//
//       auth.login({ target: to.fullPath });
//    }
//
// });





//use with auth0-spa-js lib
import { authGuard } from "../plugins/auth0/authGuard";
// import {getInstance} from "../plugins/auth0";

router.beforeEach((to, from, next) => {

   authGuard(to, from, next);



});






export default router;




